import '../../styles/modales.css'
import '../../App.css'
import React, { useEffect, useState } from "react";
import Navbar from "../../navbar/navbar";
import Sidebar from "../../navbar/sidebar";
import { InputGroup, Form, Button, Card, Table, Col, Pagination} from "react-bootstrap";
import { getAllActasSUS } from '../../services/apiService';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import { FcSearch } from 'react-icons/fc';

let monthNamesC = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

export default function ActasSusp () {
  document.title = "Actas Circunstanciadas";

  // Paginación
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [folio, setFolio] = useState("");
  const [folioInput, setFolioInput] = useState("");
  const [estadoId, setEstadoId] = useState("");
  const [estadoInput, setEstadoIdInput] = useState("");

  //Novo
  const [actas, setActas] = useState([]);

  // Inicio Paginación

  const handlePageChange = (page) => {
    setCurrentPage(page - 1);
  };
  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setCurrentPage(0);
  };
  const handlePrevious = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 0));
  };
  const handleNext = () => {
    if (totalPages === 0) return;

    setCurrentPage((prev) => Math.min(prev + 1, totalPages - 1));
  };
  const getPaginationItems = () => {
    let items = [];
    const maxVisiblePages = 5;

    let startPage = Math.max(0, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages - 1, startPage + maxVisiblePages - 1);

    // Ajustar si estamos cerca del final
    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(0, endPage - maxVisiblePages + 1);
    }

    // Primera página
    if (startPage > 0) {
      items.push(
        <Pagination.Item
          key={1}
          active={currentPage === 0}
          onClick={() => handlePageChange(1)}
        >
          1
        </Pagination.Item>
      );
      if (startPage > 1) {
        items.push(<Pagination.Ellipsis key="ellipsis-start" />);
      }
    }

    // Páginas intermedias
    for (let i = startPage; i <= endPage; i++) {
      items.push(
        <Pagination.Item
          key={i + 1}
          active={i === currentPage}
          onClick={() => handlePageChange(i + 1)}
        >
          {i + 1}
        </Pagination.Item>
      );
    }

    // Última página
    if (endPage < totalPages - 1) {
      if (endPage < totalPages - 2) {
        items.push(<Pagination.Ellipsis key="ellipsis-end" />);
      }
      items.push(
        <Pagination.Item
          key={totalPages}
          active={currentPage === totalPages - 1}
          onClick={() => handlePageChange(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    return items;
  };
  // Fin Paginación

  const handleAplicarFiltros = () => {
    setFolio(folioInput || null);
    setEstadoId(estadoInput || null);
    setCurrentPage(0); // volver a la primera página
  };

  const handleLimpiarFiltros = () => {
    setFolioInput('');
    setFolio('');
    setEstadoId('');
    setEstadoIdInput('');
    setCurrentPage(0);
  };

  const getData = async (event) => {
    try {
      let response;
      response = await getAllActasSUS(
        currentPage,
        pageSize,
        folio,
        estadoId,
      )
      setActas(response.acta || []);
      setTotalPages(response.totalPages || 0);
      setTotalElements(response.totalItems || 0);


    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line 
  }, [
    currentPage,
    pageSize,
    folio,
    estadoId,
  ]);

  return (
     <div className="flex">
          <Sidebar />
          <div className="content w-100 cont">
            <Navbar />
            <h2 className="text-center">
              <strong>ACTAS EN SUSPENSIÓN</strong>
            </h2>
    
            <Card className="card-tabla">
              <Table
                hover
                size="sm"
                responsive
                className="tablecursos text-center"
              >
                <thead className="table-dark">
                  <tr>
                    <th scope="col">Oficio</th>
                    <th scope="col">Fecha de entrada</th>
                    <th scope="col">Estatus</th>
                  </tr>
                </thead>
                <tbody>
                  {actas.length > 0 ? (
                    actas.map((acta, i) => (
    
                      <tr key={acta.id}>
                        <td>
                          <strong>{acta.folio}</strong>
                        </td>
                        <td>
                          {" " +
                            new Date(acta.creado).getUTCDate() +
                            "/" +
                            monthNamesC[new Date(acta.creado).getUTCMonth()] +
                            "/" +
                            new Date(acta.creado).getUTCFullYear()}
                        </td>
                        <td>
                          <strong>{acta.estadosacta.estado}</strong>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="10" className="text-center">
                        No hay registros para mostrar
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
    
            </Card>
    
            <Card className="card-fix">
              <div className="d-flex justify-content-between align-items-center ">
                <div className="d-flex align-items-center gap-2">
                  <Col Col xs={12} md={6} lg={6}>
                    <div className="form-group mb-4">
                      <label className="form-label">
                        <b>Folio</b>
                      </label>
                      <InputGroup className="">
                        <InputGroup.Text>
                          <FcSearch />
                        </InputGroup.Text>
                        <Form.Control
                          placeholder="Buscar por Folio..."
                          value={folioInput}
                          onChange={(e) => setFolioInput(e.target.value)}
                        />
                      </InputGroup>
                    </div>
                  </Col>
    
    
                  <Col xs={6} md={3} className="d-flex gap-2">
                    <Button
                      variant="success"
                      className="w-100"
                      onClick={handleAplicarFiltros}
                    >
                      Aplicar
                    </Button>
    
                    <Button
                      variant="dark"
                      className="w-100"
                      onClick={handleLimpiarFiltros}
                    >
                      Limpiar
                    </Button>
                  </Col>
                </div>
              </div>
    
              <div className="d-flex justify-content-between align-items-center ">
                <div className="d-flex align-items-center gap-2">
                  <span>Registros por página:</span>
                  <select
                    className="form-select form-select-sm"
                    value={pageSize}
                    onChange={handlePageSizeChange}
                    style={{ width: "80px" }}
                  >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                  </select>
    
                </div>
                <div className="text-muted">
                  Mostrando{" "}
                  <strong>
                    {currentPage * pageSize + 1}-
                    {Math.min((currentPage + 1) * pageSize, totalElements)}
                  </strong>{" "}
                  de <strong>{totalElements}</strong> registros
                </div>
    
                <div className="d-flex align-items-center gap-2">
                  <Button
                    variant="outline-dark"
                    onClick={handlePrevious}
                    disabled={currentPage === 0}
                    className="d-flex align-items-center gap-1"
                  >
                    <BsChevronLeft />
                    <span>Anterior</span>
                  </Button>
    
                  <Pagination className="mb-0">
                    {getPaginationItems()}
                  </Pagination>
    
                  <Button
                    variant="outline-dark"
                    onClick={handleNext}
                    disabled={currentPage >= totalPages - 1}
                    className="d-flex align-items-center gap-1"
                  >
                    <span>Siguiente</span>
                    <BsChevronRight />
                  </Button>
                </div>
              </div>
            </Card>
    
    
          </div>
        </div >
  );
}
